import { render, staticRenderFns } from "./TabsInPopup.vue?vue&type=template&id=ee4c6dc4&scoped=true"
import script from "./TabsInPopup.vue?vue&type=script&lang=js"
export * from "./TabsInPopup.vue?vue&type=script&lang=js"
import style0 from "./TabsInPopup.vue?vue&type=style&index=0&id=ee4c6dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4c6dc4",
  null
  
)

export default component.exports